import { styled, keyframes } from '@mui/system';
import {
  Card,
  CardHeader,
  CardContent as MuiCardContent,
  ListItemIcon as MuiListItemIcon,
  Typography
} from '@mui/material';

const blinkAnimation = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`;

export const ShowMoreContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const CardsContainer = styled('div')(() => ({
  textAlign: 'center'
}));

export const LoadingContainer = styled(CardsContainer)(() => ({
  '& > div': {
    animation: `${blinkAnimation} 1s alternate infinite linear`
  }
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  textAlign: 'left',
  width: '100%',
  boxShadow: 'none',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    width: '47%',
    marginRight: theme.spacing(),
    marginLeft: theme.spacing()
  },
  [theme.breakpoints.up('md')]: {
    width: '33%',
    marginRight: theme.spacing(),
    marginLeft: theme.spacing()
  },
  display: 'inline-block',
  verticalAlign: 'top',
  position: 'relative'
}));

export const CardHeaderContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 0'
}));

export const HeaderTextContainer = styled('div')(() => ({}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: theme.spacing(),
  paddingLeft: theme.spacing(2),
  whiteSpace: 'pre',
  '& .MuiCardHeader-avatar': {
    marginRight: 0
  }
}));

export const StyledListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  justifyContent: 'flex-end'
}));

export const StyledCardContent = styled(MuiCardContent)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const Title2 = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontWeight: '500',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 0
  }
}));

export const UsersButtonContainer = styled('div')(() => ({}));
